import { setLocale } from 'yup'

setLocale({
  mixed: {
    required: 'Common.error.required',
  },
})
